var map = {
	"./Contactus.png": 5347,
	"./Fuel Bundle Inspection and Testing Assembly.webp": 5894,
	"./Grid motor housing.webp": 3707,
	"./Guideway Roller Bearing Assemblies.webp": 4568,
	"./Manufacturing.png": 1578,
	"./SS–Aluminium Transition Joints.webp": 5777,
	"./STEAM EJECTOR ASSEMBLIES.webp": 4849,
	"./VisionMission.png": 3537,
	"./aboutHomeBg.jpg": 9444,
	"./aboutImage.jpg": 829,
	"./aboutImage.png": 7661,
	"./aboutInfo.png": 6532,
	"./aboutmain.webp": 5827,
	"./aerospace.png": 2244,
	"./certificates/ACHILLES CERTIFICATE.jpg": 336,
	"./certificates/Certificate of Incorporation/first.jpg": 5454,
	"./certificates/Certificate of Incorporation/second.jpg": 5786,
	"./certificates/HAL Registration Certificate/first.jpg": 2360,
	"./certificates/HAL Registration Certificate/second.jpg": 8028,
	"./certificates/IAF Registration Certificate/first.jpg": 2225,
	"./certificates/IAF Registration Certificate/second.jpg": 9799,
	"./certificates/ISO 14001.png": 9793,
	"./certificates/ISO 9001-2015.jpg": 5674,
	"./certificates/ISO 9001.png": 6919,
	"./certificates/gstcertificate.png": 3,
	"./certificates/haloutsourcing/first.jpg": 6092,
	"./certificates/haloutsourcing/second.jpg": 3112,
	"./certification.png": 73,
	"./client1.png": 7045,
	"./client10.png": 5313,
	"./client2.png": 9214,
	"./client3.png": 8711,
	"./client4.png": 2920,
	"./client5.png": 4049,
	"./client6.png": 6618,
	"./client7.png": 8531,
	"./client8.png": 6260,
	"./client9.png": 7389,
	"./clientsBackground.png": 4363,
	"./coating/cadmium.png": 553,
	"./coating/chromium.png": 2789,
	"./coating/diamond.png": 9525,
	"./coating/hardchrome.png": 7692,
	"./coating/nitriding.png": 5199,
	"./coating/zinccoating.png": 3036,
	"./codeofconduct/Anti Bribery and Corruption.pdf": 57,
	"./codeofconduct/COC POLICIES.pdf": 5525,
	"./codeofconduct/Child Labour Policy.pdf": 3999,
	"./codeofconduct/Code of conduct - HARDCOATS.pdf": 7262,
	"./codeofconduct/Environment policy.pdf": 5235,
	"./codeofconduct/FRAUD POLICY.pdf": 8232,
	"./codeofconduct/Forced Labour policy.pdf": 830,
	"./codeofconduct/Freedom of association.pdf": 4244,
	"./codeofconduct/HAZARDOUS SUBSTANCE POLICY.pdf": 8269,
	"./codeofconduct/Health and Safety Policy.pdf": 6933,
	"./codeofconduct/PPE Management policy.pdf": 5468,
	"./codeofconduct/SECURITY POLICY REPLY.pdf": 2232,
	"./codeofconduct/SUSTAINABILITY POLICY.pdf": 6839,
	"./codeofconduct/Safety Procedure.pdf": 4549,
	"./dairy.png": 610,
	"./defense.png": 4735,
	"./energy.png": 1439,
	"./footerlogo.png": 9927,
	"./fusion.png": 6007,
	"./headerlogo.png": 6853,
	"./hexagon - Copy.png": 7323,
	"./hexagon.png": 5111,
	"./homeAbout.png": 3367,
	"./homevideo.mp4": 9736,
	"./homewhatwedo/design.png": 4046,
	"./homewhatwedo/manufacturing.webp": 9592,
	"./homewhatwedo/precisioncomponents.webp": 6286,
	"./homewhatwedo/quality.png": 3161,
	"./homewhatwedo/testinghome.png": 4763,
	"./image10.png": 3335,
	"./logosmall.png": 4857,
	"./manufacturing/0S0A0811_1_11zon.webp": 9700,
	"./manufacturing/0S0A0842_4_11zon.webp": 1691,
	"./manufacturing/0S0A0848_6_11zon.webp": 5879,
	"./manufacturing/five.webp": 1806,
	"./manufacturing/three.webp": 1566,
	"./manufacturing/two.webp": 24,
	"./metallicseal/1.png": 1311,
	"./metallicseal/2.png": 6052,
	"./metallicseal/Picture3 (1).jpg": 6455,
	"./metallicseal/nozzle1.png": 7019,
	"./metallicseal/nozzle2.png": 9376,
	"./oil.png": 9667,
	"./packaging.png": 6602,
	"./packaging/WhatsApp Image 2026-10-09 at 15.42.08.jpeg": 7454,
	"./packaging/WhatsApp Image 2026-10-09 at 15.42.39.jpeg": 3930,
	"./packaging/WhatsApp Image 2026-10-09 at 15.54.07 (1).jpeg": 9332,
	"./piston tubes.webp": 7151,
	"./pistonseal/1.png": 8343,
	"./pistonseal/2.png": 3260,
	"./pistonseal/3.png": 7125,
	"./pistonseal/4.png": 2458,
	"./pistonseal/5.png": 3219,
	"./power.png": 2832,
	"./precision2/1.jpg": 8605,
	"./precision2/10.jpg": 5553,
	"./precision2/11.png": 4496,
	"./precision2/12.jpg": 3459,
	"./precision2/13.jpg": 3350,
	"./precision2/14.jpg": 9549,
	"./precision2/15.jpg": 4656,
	"./precision2/16.jpg": 2031,
	"./precision2/17.jpg": 322,
	"./precision2/18.jpg": 4809,
	"./precision2/19.jpg": 4284,
	"./precision2/2.png": 3750,
	"./precision2/20.jpg": 4816,
	"./precision2/21.jpg": 5949,
	"./precision2/22.jpg": 6050,
	"./precision2/23.jpg": 8431,
	"./precision2/24.jpg": 3492,
	"./precision2/25.jpg": 1537,
	"./precision2/26.jpg": 4838,
	"./precision2/27.jpg": 1299,
	"./precision2/28.jpg": 3160,
	"./precision2/3.jpg": 6031,
	"./precision2/4.jpg": 9652,
	"./precision2/5.jpg": 7697,
	"./precision2/6.jpg": 8086,
	"./precision2/7.png": 7083,
	"./precision2/8.jpg": 8203,
	"./precision2/9.png": 8373,
	"./precisionone/bottomend.png": 3494,
	"./precisionone/capsule.png": 8239,
	"./precisionone/capsule2.png": 4125,
	"./precisionone/feed.png": 84,
	"./precisionone/link.png": 1736,
	"./precisionone/lvdt.png": 1310,
	"./precisionone/pinion.png": 7717,
	"./precisionone/poppet.png": 8792,
	"./precisionone/poppettwo.png": 8524,
	"./precisionone/topend.png": 8248,
	"./precisionone/valve.png": 3992,
	"./precisionone/valvetwo.png": 124,
	"./precisionthree/1.png": 1251,
	"./precisionthree/2.png": 6760,
	"./precisionthree/3.png": 9473,
	"./precisionthree/4.png": 6382,
	"./precisiontwo/1.png": 8521,
	"./precisiontwo/10.png": 349,
	"./precisiontwo/11.png": 6452,
	"./precisiontwo/12.png": 3311,
	"./precisiontwo/2.png": 7554,
	"./precisiontwo/3.png": 2379,
	"./precisiontwo/4.png": 8516,
	"./precisiontwo/5.png": 2413,
	"./precisiontwo/6.png": 8438,
	"./precisiontwo/7.png": 5375,
	"./precisiontwo/8.png": 5528,
	"./precisiontwo/9.png": 5745,
	"./precisiontwo/Ball-way Guideway Bearing.webp": 288,
	"./precisiontwo/Ball-way Guideway Bearing2.jpeg": 9353,
	"./precisiontwo/Component Transfer Assembly.mp4": 4237,
	"./precisiontwo/Containment Isolation Valve.mp4": 7289,
	"./precisiontwo/DRIVE MECHANISM FOR SHUT-OFF ROD.png": 3257,
	"./precisiontwo/PIN MAGAZINE ASSEMBLY.png": 911,
	"./precisiontwo/SPECIAL BALL VALVE ASSEMBLY.mp4": 5529,
	"./precisiontwo/Wet Quarantine Plug.webp": 3788,
	"./productlist/Coating&plating.png": 3871,
	"./productlist/Precisionassemblies.png": 7975,
	"./productlist/indigenouslydevelopedseals.png": 7505,
	"./productlist/metallicfaceseals.png": 6133,
	"./productlist/pistonrodseals.png": 4451,
	"./productlist/precisioncomponents.png": 6379,
	"./productlist/specialgradealloyparts.png": 8020,
	"./quality/0S0A0714_1_11zon.webp": 99,
	"./quality/four.webp": 2171,
	"./quality/three.webp": 6241,
	"./quality/two.jpeg": 9844,
	"./quote.png": 5415,
	"./research.png": 7516,
	"./slideOne.webp": 8302,
	"./slideThree.webp": 4214,
	"./slideTwo.webp": 2864,
	"./testing.png": 5791,
	"./testing/1.webp": 3331,
	"./testing/2.webp": 7986,
	"./testing/3.webp": 7901,
	"./testing/4.webp": 2975,
	"./testing/5.webp": 3295,
	"./w1.png": 9375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4867;